import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4cc1fe30"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-banner"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "subtitle"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_5 = {
  class: "desc"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "c-banner-width",
    style: _normalizeStyle({
      backgroundImage: !$props.nobg ? `url(${require(`@/assets/banner/${_ctx.$route.name}.png`)})` : ''
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(["c-content", {
      white: $props.white
    }])
  }, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.info.title), 1), _createElementVNode("div", _hoisted_3, _toDisplayString($data.info.sub), 1), _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.info.desc), 1), _renderSlot(_ctx.$slots, "btn", {}, () => [!$props.nobtn ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "large",
    class: "btn",
    onClick: $options.handleGo
  }, {
    default: _withCtx(() => [_createTextVNode("立即体验")]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)], true)], 2)], 4)]);
}